import type { Platform } from '../types';
import { PlatformRegistry } from './registry';

export const copylink: Platform = {
  id: 'copylink',
  name: 'Copy link',
  iconIndex: PlatformRegistry.copylink.index,
  color: PlatformRegistry.copylink.color,
  buildUrl: (): null => {
    // Copy link doesn't navigate anywhere
    return null;
  },
};

